import { api } from 'app/sdk/utils/trunkingio';

const exports = {
    list: async (accountId, options) => {
        const response = await api.get(`/accounts/${accountId}/carriers`, options);
        return response.data;
    },
    listMaster: async options => {
        const response = await api.get(`/carriers`, options);
        return response.data;
    },
    get: async (accountId, carrierId, options) => {
        const response = await api.get(`/accounts/${accountId}/carriers/${carrierId}`, options);
        return response.data;
    },
    create: async (accountId, payload, options) => {
        const response = await api.put(`/accounts/${accountId}/carriers`, payload, options);
        return response.data;
    },
    patch: async (accountId, carrierId, payload, options) => {
        const response = await api.patch(`/accounts/${accountId}/carriers/${carrierId}`, payload, options);
        return response.data;
    },
    delete: async (accountId, carrierId, options) => {
        const response = await api.delete(`/accounts/${accountId}/carriers/${carrierId}`, options);
        return response.data;
    },
};

export default exports;
